import { api } from "./backend";

export function crear() {
  return {
    id: 0,
    descripcion: "",
    descuento: "",
    usablePorResponsable: false,
    usablePorComercial: false,
    estado: false,
    paraCuota: false,
    paraServicios: false,
  };
}

export function listar() {
  return api.get("tiposDescuento/listar").then((r) => r.data);
}

export function cargar(id) {
  return api.get("tiposDescuento/cargar&id=" + id).then((response) => {
    var data = response.data.tipoDescuento;
    data.estado = Boolean(data.estado);
    data.usablePorResponsable = Boolean(data.usablePorResponsable);
    data.usablePorComercial = Boolean(data.usablePorComercial);
    data.paraCuota = Boolean(data.paraCuota);
    data.paraServicios = Boolean(data.paraServicios);
    return data;
  });
}

export function insertar(descuento) {
  return api.post("tiposDescuento/insertar", {
    tipoDescuento: descuento.descuento,
  });
}

export function actualizar(descuento) {
  return api.post("tiposDescuento/actualizar", {
    tipoDescuento: descuento.descuento,
  });
}

export function eliminar(id) {
  return api.post("tiposDescuento/eliminar", { id });
}
